import React from "react";

import { useNavigate } from "react-router-dom";
import { styled } from "@mui/material/styles";

import BackArrow from "../../assets/icons/BackArrow.svg";
// import { TrackingContext } from "../../bit/tracking";
// import useEventTracking from "../../bit/tracking/useEventTracking";

interface BackButtonProps {
  to: string;
}

const StyledButton = styled("button")(({ theme }) => ({
  zIndex: 10,
  position: "absolute",
  left: "2.8rem",
  display: "flex",
  alignItems: "center",
  color: theme.palette.primary.main,
  path: {
    fill: theme.palette.primary.main,
  },
  svg: {
    marginRight: "1.6rem",
  },

  "@media screen and (orientation: landscape)": {
    top: "42.6rem",
  },
}));

const BackButton = ({ to }: BackButtonProps) => {
  const navigate = useNavigate();

  // const { getPageData } = useContext(TrackingContext);

  // const { trackEvent } = useEventTracking();

  return (
    <StyledButton
      onClick={() => {
        // const pageData = getPageData();

        // if (pageData) {
        // trackEvent({ type: "back_button_click", value: pageData.page });
        // }

        navigate(to);
      }}
    >
      <BackArrow width="7rem" />
    </StyledButton>
  );
};

export default React.memo(BackButton);
